import auth from '../../Services/auth';

export const checkForUserPVD = () => {
    const user = auth.getUser();
    return user?.isPVDUser;
};
